import React, { Fragment } from "react";
import Header from "../components/Header";
import Sidebar from "../components/Sidebar";
import Footer from "../components/Footer";
import Loader from "../components/Loader";
import PageHeader from "../components/PageHeader";
import { SITENAMEALIAS } from "../utils/init";
import { Link, withRouter } from "react-router-dom";
import Moment from "react-moment";
import {
  showToast,
  showHttpError,
  handleCurrencyDetiails,
  handleDynamicCurrencyDetiails,
  formatAmount,
  _isOnlyNumber,
} from "../utils/library";
import { Modal } from "react-bootstrap";
import {
  FetchMerchantStatus,
  GetAllInvoices,
  GetAllPaidResolvedInvoice,
  getAllUnresolvedInvoice,
  searchAllInvoices,
  FetchUsdBtcLedgerAmount,
  updateInvoiceStatus,
  GetTestInvoices,
  get_refund_list,
  update_refund_status,
  getAuthToken,
  getAuthUuid,
} from "../utils/service";

const ps = {
  pageWrapper: {
    padding: "36px 24px 60px",
  },
  headerRow: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: "28px",
    flexWrap: "wrap",
    gap: "16px",
  },
  pageTitle: {
    fontSize: "24px",
    fontWeight: "700",
    color: "var(--text-color)",
    margin: 0,
  },
  pageSubtitle: {
    fontSize: "13px",
    opacity: 0.5,
    margin: "4px 0 0",
  },
  searchBox: {
    display: "flex",
    alignItems: "center",
    gap: "0",
    background: "var(--body-color)",
    border: "1px solid var(--body-color-less2)",
    borderRadius: "10px",
    overflow: "hidden",
    width: "320px",
    flexShrink: 0,
  },
  searchInput: {
    flex: 1,
    padding: "9px 14px",
    fontSize: "13px",
    border: "none",
    outline: "none",
    background: "transparent",
    color: "var(--text-color)",
  },
  searchBtn: {
    padding: "11px 18px",
    background: "var(--btn-color)",
    color: "#fff",
    border: "none",
    fontSize: "13px",
    fontWeight: "600",
    cursor: "pointer",
    transition: "opacity 0.2s",
    whiteSpace: "nowrap",
  },
  filterBar: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    marginBottom: "20px",
  },
  filterBtn: (isActive) => ({
    padding: "7px 20px",
    fontSize: "13px",
    fontWeight: "600",
    borderRadius: "8px",
    border: isActive ? "none" : "1px solid var(--body-color-less2)",
    background: isActive ? "var(--btn-color)" : "transparent",
    color: isActive ? "#fff" : "var(--text-color)",
    cursor: "pointer",
    transition: "all 0.2s ease",
    opacity: isActive ? 1 : 0.7,
  }),
  card: {
    background: "var(--body-color-less)",
    borderRadius: "16px",
    border: "1px solid var(--body-color-less2)",
    boxShadow: "0 2px 12px rgba(0,0,0,0.06)",
    overflow: "hidden",
  },
  tableWrapper: {
    overflowX: "auto",
    overflowY: "hidden",
    WebkitOverflowScrolling: "touch",
  },
  table: {
    width: "100%",
    borderCollapse: "collapse",
  },
  th: {
    padding: "14px 16px",
    fontSize: "11px",
    fontWeight: "700",
    textTransform: "uppercase",
    letterSpacing: "0.5px",
    color: "var(--text-color)",
    opacity: 0.5,
    borderBottom: "1px solid var(--body-color-less2)",
    textAlign: "left",
    whiteSpace: "nowrap",
    background: "var(--body-color-less)",
  },
  td: {
    padding: "14px 16px",
    fontSize: "13px",
    borderBottom: "1px solid var(--body-color-less2)",
    verticalAlign: "middle",
    whiteSpace: "nowrap",
  },
  trHover: {
    transition: "background 0.15s ease",
  },
  statusBadge: (color) => ({
    display: "inline-flex",
    alignItems: "center",
    gap: "5px",
    padding: "4px 12px",
    borderRadius: "20px",
    fontSize: "11px",
    fontWeight: "600",
    background:
      color === "green"
        ? "rgba(16,185,129,0.1)"
        : color === "red"
        ? "rgba(239,68,68,0.1)"
        : color === "blue"
        ? "rgba(59,130,246,0.1)"
        : color === "amber"
        ? "rgba(245,158,11,0.1)"
        : "rgba(107,114,128,0.1)",
    color:
      color === "green"
        ? "#10b981"
        : color === "red"
        ? "#ef4444"
        : color === "blue"
        ? "#3b82f6"
        : color === "amber"
        ? "#f59e0b"
        : "#6b7280",
  }),
  statusDot: (color) => ({
    width: "6px",
    height: "6px",
    borderRadius: "50%",
    background:
      color === "green"
        ? "#10b981"
        : color === "red"
        ? "#ef4444"
        : color === "blue"
        ? "#3b82f6"
        : color === "amber"
        ? "#f59e0b"
        : "#6b7280",
  }),
  checkbox: {
    width: "16px",
    height: "16px",
    cursor: "pointer",
    accentColor: "var(--btn-color)",
  },
  paginationRow: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "4px",
    padding: "20px 16px",
    borderTop: "1px solid var(--body-color-less2)",
  },
  pageBtn: (isActive) => ({
    minWidth: "36px",
    height: "36px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "8px",
    border: isActive ? "none" : "1px solid var(--body-color-less2)",
    background: isActive ? "var(--btn-color)" : "transparent",
    color: isActive ? "#fff" : "var(--text-color)",
    fontSize: "13px",
    fontWeight: "600",
    cursor: "pointer",
    transition: "all 0.2s ease",
    opacity: isActive ? 1 : 0.6,
  }),
  emptyState: {
    padding: "60px 20px",
    textAlign: "center",
  },
  emptyIcon: {
    fontSize: "48px",
    opacity: 0.15,
    marginBottom: "16px",
  },
  emptyText: {
    fontSize: "14px",
    opacity: 0.4,
    fontWeight: "500",
  },
  countBadge: {
    fontSize: "12px",
    fontWeight: "600",
    opacity: 0.4,
    marginLeft: "8px",
  },
  actionBtn: (color) => ({
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    width: "34px",
    height: "34px",
    borderRadius: "8px",
    border: "none",
    cursor: "pointer",
    transition: "all 0.2s ease",
    background:
      color === "red"
        ? "rgba(239,68,68,0.1)"
        : color === "green"
        ? "rgba(16,185,129,0.1)"
        : "var(--body-color-less2)",
    color:
      color === "red"
        ? "#ef4444"
        : color === "green"
        ? "#10b981"
        : "var(--text-color)",
    fontSize: "14px",
    marginRight: "6px",
  }),
  modalHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "20px 24px",
    borderBottom: "1px solid var(--body-color-less2)",
  },
  modalTitle: {
    fontSize: "18px",
    fontWeight: "700",
    margin: 0,
  },
  modalClose: {
    width: "32px",
    height: "32px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "8px",
    border: "none",
    background: "var(--body-color-less2)",
    cursor: "pointer",
    fontSize: "18px",
    color: "var(--text-color)",
    opacity: 0.6,
  },
  modalBody: {
    padding: "24px",
  },
  modalLabel: {
    fontSize: "12px",
    fontWeight: "600",
    textTransform: "uppercase",
    letterSpacing: "0.3px",
    opacity: 0.7,
    marginBottom: "6px",
    display: "block",
  },
  modalInput: {
    width: "100%",
    padding: "10px 14px",
    fontSize: "14px",
    borderRadius: "10px",
    border: "1px solid var(--body-color-less2)",
    background: "var(--body-color)",
    color: "var(--text-color)",
    outline: "none",
    boxSizing: "border-box",
    marginBottom: "16px",
  },
  modalRequestedBadge: {
    display: "inline-flex",
    alignItems: "center",
    gap: "6px",
    padding: "8px 16px",
    background:
      "linear-gradient(135deg, color-mix(in srgb, var(--btn-color), transparent 90%), color-mix(in srgb, var(--btn-color), transparent 95%))",
    borderRadius: "10px",
    fontSize: "13px",
    fontWeight: "600",
    marginBottom: "20px",
    border: "1px solid color-mix(in srgb, var(--btn-color), transparent 80%)",
  },
  modalFooter: {
    display: "flex",
    gap: "10px",
    padding: "0 24px 24px",
  },
  btnRefund: {
    flex: 1,
    padding: "11px 20px",
    background: "var(--btn-color)",
    color: "#fff",
    border: "none",
    borderRadius: "10px",
    fontSize: "13px",
    fontWeight: "600",
    cursor: "pointer",
    transition: "all 0.2s ease",
  },
  btnRefundFull: {
    flex: 1,
    padding: "11px 20px",
    background: "#10b981",
    color: "#fff",
    border: "none",
    borderRadius: "10px",
    fontSize: "13px",
    fontWeight: "600",
    cursor: "pointer",
    transition: "all 0.2s ease",
  },
  btnDisabled: {
    opacity: 0.4,
    cursor: "not-allowed",
  },
  issueRefundHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "24px 28px 20px",
    borderBottom: "1px solid var(--body-color-less2)",
  },
  issueRefundTitle: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
    fontSize: "20px",
    fontWeight: "700",
    margin: 0,
    color: "var(--text-color)",
  },
  issueRefundTitleIcon: {
    width: "36px",
    height: "36px",
    borderRadius: "10px",
    background:
      "linear-gradient(135deg, rgba(99,102,241,0.12), rgba(99,102,241,0.06))",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "16px",
    color: "#6366f1",
  },
  issueRefundBody: {
    padding: "24px 28px",
  },
  issueRefundInvoiceBadge: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "16px 20px",
    background:
      "linear-gradient(135deg, rgba(99,102,241,0.08), rgba(59,130,246,0.05))",
    borderRadius: "12px",
    border: "1px solid rgba(99,102,241,0.12)",
    marginBottom: "24px",
  },
  issueRefundInvoiceLabel: {
    fontSize: "12px",
    fontWeight: "600",
    textTransform: "uppercase",
    letterSpacing: "0.5px",
    opacity: 0.5,
    marginBottom: "4px",
  },
  issueRefundInvoiceValue: {
    fontSize: "15px",
    fontWeight: "700",
    fontFamily: "monospace",
    color: "#6366f1",
  },
  issueRefundTotalPaid: {
    fontSize: "15px",
    fontWeight: "700",
    textAlign: "right",
  },
  issueRefundFieldGroup: {
    marginBottom: "20px",
  },
  issueRefundLabel: {
    display: "block",
    fontSize: "13px",
    fontWeight: "600",
    color: "var(--text-color)",
    marginBottom: "8px",
  },
  issueRefundInput: {
    width: "100%",
    padding: "12px 16px",
    fontSize: "14px",
    fontWeight: "500",
    borderRadius: "10px",
    border: "1px solid var(--body-color-less2)",
    background: "var(--body-color)",
    color: "var(--text-color)",
    outline: "none",
    boxSizing: "border-box",
    transition: "border-color 0.2s ease",
  },
  issueRefundSelect: {
    width: "100%",
    padding: "12px 16px",
    fontSize: "14px",
    fontWeight: "500",
    borderRadius: "10px",
    border: "1px solid var(--body-color-less2)",
    background: "var(--body-color)",
    color: "var(--text-color)",
    outline: "none",
    boxSizing: "border-box",
    cursor: "pointer",
    appearance: "none",
    backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%236b7280' d='M6 8L1 3h10z'/%3E%3C/svg%3E")`,
    backgroundRepeat: "no-repeat",
    backgroundPosition: "right 14px center",
    paddingRight: "36px",
  },
  issueRefundTextarea: {
    width: "100%",
    padding: "12px 16px",
    fontSize: "14px",
    borderRadius: "10px",
    border: "1px solid var(--body-color-less2)",
    background: "var(--body-color)",
    color: "var(--text-color)",
    outline: "none",
    boxSizing: "border-box",
    resize: "vertical",
    minHeight: "80px",
    fontFamily: "inherit",
  },
  issueRefundInfoRow: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "10px 0",
    borderBottom: "1px solid var(--body-color-less2)",
    fontSize: "13px",
  },
  issueRefundInfoLabel: {
    opacity: 0.6,
    fontWeight: "500",
  },
  issueRefundInfoValue: {
    fontWeight: "600",
    fontFamily: "monospace",
  },
  issueRefundFooter: {
    display: "flex",
    gap: "12px",
    padding: "0 28px 24px",
  },
  issueRefundBtnCancel: {
    flex: 1,
    padding: "13px 20px",
    background: "var(--body-color)",
    color: "var(--text-color)",
    border: "1px solid var(--body-color-less2)",
    borderRadius: "10px",
    fontSize: "14px",
    fontWeight: "600",
    cursor: "pointer",
    transition: "all 0.2s ease",
  },
  issueRefundBtnSubmit: {
    flex: 1,
    padding: "13px 20px",
    background: "linear-gradient(135deg, #6366f1, #4f46e5)",
    color: "#fff",
    border: "none",
    borderRadius: "10px",
    fontSize: "14px",
    fontWeight: "600",
    cursor: "pointer",
    transition: "all 0.2s ease",
    boxShadow: "0 2px 8px rgba(99,102,241,0.3)",
  },
  issueRefundDisclaimer: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    padding: "16px 28px 20px",
    borderTop: "1px solid var(--body-color-less2)",
    fontSize: "12px",
    opacity: 0.5,
    fontWeight: "500",
    lineHeight: "1.5",
  },
  issueRefundDivider: {
    height: "1px",
    background: "var(--body-color-less2)",
    margin: "4px 0 20px",
  },
};

const getStatusInfo = (status) => {
  const s = String(status);
  if (["16", "17", "18", "19", "20"].includes(s))
    return { label: "Paid", color: "green" };
  if (s === "13") return { label: "Over Paid", color: "blue" };
  if (s === "14") return { label: "Under Paid", color: "red" };
  if (s === "12") return { label: "Created", color: "blue" };
  if (s === "21") return { label: "Processing", color: "amber" };
  if (s === "15") return { label: "Refund Requested", color: "amber" };
  if (s === "34") return { label: "Refund Approved", color: "green" };
  if (s === "43") return { label: "Confirmed", color: "green" };
  if (s === "30") return { label: "Failed", color: "red" };
  if (s === "44") return { label: "Token Sent", color: "blue" };
  return { label: "", color: "grey" };
};

class Payments extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showLoader: false,
      pageNo: 1,
      noOfItemsPerPage: 20,
      txnType: "all",
      paymentList: [],
      pageList: [],
      totalCount: 0,
      refundList: [],
      refundModalOpen: false,
      selectedInvoiceId: null,
      requestedRefundAmount: null,
      refundAmountInput: null,
      selectedCurrencyCode: "",
      issueRefundModalOpen: false,
      issueRefundItem: null,
      issueRefundAmount: "",
      issueRefundReason: "Customer Request",
      issueRefundNote: "",
    };

    this.searchString = React.createRef();
  }

  handleRenderAssets = () => {
    let payload = {
      merchant_id: localStorage.getItem(SITENAMEALIAS + "_merchant_id"),
    };
    this.setState({ showLoader: true });

    FetchUsdBtcLedgerAmount(payload)
      .then(
        function (res) {
          this.setState({ showLoader: false });
          let response = res.data[0];
          console.log(response);
          if (response.error != "0") {
            showToast("error", response.error_msg);
          } else {
            if (response != undefined && response != null) {
              let coinBalance = response.coin_balance;
              let arr = [];
              if (coinBalance != undefined) {
                for (let i = 0; i < coinBalance.length; i++) {
                  if (coinBalance[i].currency_code != "USD") {
                    let obj = {
                      assetName: coinBalance[i].currency_name,
                      coinBalance: coinBalance[i].balance,
                      assetCode: coinBalance[i].currency_code,
                      assetId: coinBalance[i].currency_id,
                      assetImage: coinBalance[i].logo,
                      network: coinBalance[i].network,
                      isBrokerCurrency: coinBalance[i].is_broker_currency,
                    };
                    arr.push(obj);
                  }
                }
              }

              this.setState(
                {
                  assets: arr,
                },
                () => {
                  console.log(this.state.assets);
                  localStorage.setItem(
                    SITENAMEALIAS + "_assets",
                    JSON.stringify(this.state.assets)
                  );
                  this.handleAllInvoice();
                }
              );
            }
          }
        }.bind(this)
      )
      .catch(
        function (err) {
          this.setState({ showLoader: false });
          console.log("4", err);
          showHttpError(err);
        }.bind(this)
      );
  };

  handleAllInvoice = () => {
    let payload = {
      merchant_id: parseInt(
        localStorage.getItem(SITENAMEALIAS + "_merchant_id")
      ),
      page_no: this.state.pageNo,
      no_of_items_in_a_page: this.state.noOfItemsPerPage,
    };
    this.setState({ showLoader: true });

    GetAllInvoices(payload)
      .then(
        function (res) {
          this.setState({ showLoader: false });
          let response = res.data;
          let errorObj = response[response.length - 1];
          if (errorObj.error != "0") {
            showToast("error", errorObj.error_msg);
          } else {
            let arr = [];
            for (let i = 0; i < response.length - 1; i++) {
              arr.push(response[i]);
            }
            this.setState(
              {
                paymentList: arr,
                totalCount: errorObj.total_count,
              },
              () => {
                this.renderPaginationPageNo();
              }
            );
          }
        }.bind(this)
      )
      .catch(
        function (err) {
          this.setState({ showLoader: false });
          showHttpError(err);
        }.bind(this)
      );
  };

  handleAllPaidInvoice = () => {
    let payload = {
      merchant_id: parseInt(
        localStorage.getItem(SITENAMEALIAS + "_merchant_id")
      ),
      page_no: this.state.pageNo,
      no_of_items_in_a_page: this.state.noOfItemsPerPage,
    };
    this.setState({ showLoader: true });

    GetAllPaidResolvedInvoice(payload)
      .then(
        function (res) {
          this.setState({ showLoader: false });
          let response = res.data;
          let errorObj = response[response.length - 1];
          if (errorObj.error != "0") {
            showToast("error", errorObj.error_msg);
          } else {
            let arr = [];
            for (let i = 0; i < response.length - 1; i++) {
              arr.push(response[i]);
            }
            this.setState(
              {
                paymentList: arr,
                totalCount: errorObj.total_count,
              },
              () => {
                this.renderPaginationPageNo();
              }
            );
          }
        }.bind(this)
      )
      .catch(
        function (err) {
          this.setState({ showLoader: false });
          showHttpError(err);
        }.bind(this)
      );
  };

  handleAllUnResolvedInvoice = () => {
    let payload = {
      merchant_id: parseInt(
        localStorage.getItem(SITENAMEALIAS + "_merchant_id")
      ),
      page_no: this.state.pageNo,
      no_of_items_in_a_page: this.state.noOfItemsPerPage,
    };
    this.setState({ showLoader: true });

    getAllUnresolvedInvoice(payload)
      .then(
        function (res) {
          this.setState({ showLoader: false });
          let response = res.data;
          let errorObj = response[response.length - 1];
          if (errorObj.error != "0") {
            showToast("error", errorObj.error_msg);
          } else {
            let arr = [];
            for (let i = 0; i < response.length - 1; i++) {
              arr.push(response[i]);
            }
            this.setState(
              {
                paymentList: arr,
                totalCount: errorObj.total_count,
              },
              () => {
                this.renderPaginationPageNo();
              }
            );
          }
        }.bind(this)
      )
      .catch(
        function (err) {
          this.setState({ showLoader: false });
          showHttpError(err);
        }.bind(this)
      );
  };

  markUserAsTestUser = (obj, event) => {
    console.log(obj, event);

    let payload = {
      merchant_id: obj.merchant_id,
      invoice_id: obj.invoice_id,
    };
    if (event.target.checked) {
      payload["status"] = 1;
    } else {
      payload["status"] = 0;
    }
    this.setState({ showLoader: true });

    updateInvoiceStatus(payload)
      .then(
        function (res) {
          this.setState({ showLoader: false });
          let response = res.data;
          let errorObj = response[response.length - 1];
          if (errorObj.error != "0") {
            showToast("error", errorObj.error_msg);
          } else {
            if (payload.status == 1) {
              showToast("success", "Invoice updated as test user");
            } else {
              showToast("success", "Invoice updated as real user");
            }
            if (this.state.txnType == "all") {
              this.handleAllInvoice();
            } else if (this.state.txnType == "paid") {
              this.handleAllPaidInvoice();
            } else if (this.state.txnType == "testuser") {
              this.handleAllTestUser();
            } else {
              this.handleAllUnResolvedInvoice();
            }
          }
        }.bind(this)
      )
      .catch(
        function (err) {
          this.setState({ showLoader: false });
          showHttpError(err);
        }.bind(this)
      );
  };

  handleAllTestUser = () => {
    let payload = {
      merchant_id: parseInt(
        localStorage.getItem(SITENAMEALIAS + "_merchant_id")
      ),
      page_no: this.state.pageNo,
      no_of_items_in_a_page: this.state.noOfItemsPerPage,
    };
    this.setState({ showLoader: true });

    GetTestInvoices(payload)
      .then(
        function (res) {
          this.setState({ showLoader: false });
          let response = res.data;
          let errorObj = response[response.length - 1];
          if (errorObj.error != "0") {
            showToast("error", errorObj.error_msg);
          } else {
            let arr = [];
            for (let i = 0; i < response.length - 1; i++) {
              arr.push(response[i]);
            }
            this.setState(
              {
                paymentList: arr,
                totalCount: errorObj.total_count,
              },
              () => {
                this.renderPaginationPageNo();
              }
            );
          }
        }.bind(this)
      )
      .catch(
        function (err) {
          this.setState({ showLoader: false });
          showHttpError(err);
        }.bind(this)
      );
  };

  handleSearchAllInvoice = () => {
    if (this.searchString.current.value != "") {
      let payload = {
        merchant_id: parseInt(
          localStorage.getItem(SITENAMEALIAS + "_merchant_id")
        ),
        page_no: this.state.pageNo,
        no_of_items_in_a_page: this.state.noOfItemsPerPage,
        search_string: this.searchString.current.value,
      };
      this.setState({ showLoader: true });

      searchAllInvoices(payload)
        .then(
          function (res) {
            this.setState({ showLoader: false });
            let response = res.data;
            let errorObj = response[response.length - 1];
            if (errorObj.error != "0") {
              showToast("error", errorObj.error_msg);
            } else {
              let arr = [];
              for (let i = 0; i < response.length - 1; i++) {
                arr.push(response[i]);
              }
              this.setState(
                {
                  paymentList: arr,
                  totalCount: errorObj.total_count,
                },
                () => {
                  this.renderPaginationPageNo();
                }
              );
            }
          }.bind(this)
        )
        .catch(
          function (err) {
            this.setState({ showLoader: false });
            showHttpError(err);
          }.bind(this)
        );
    } else {
      showToast("error", "Search keyword cannot be blank");
    }
  };

  getRefundList = () => {
    let payload = {
      merchant_uuid: getAuthUuid(),
    };
    this.setState({ showLoader: true });
    get_refund_list(payload)
      .then(
        function (res) {
          let response = res.data[0];
          this.setState({ showLoader: false });
          if (response.error != "0") {
            showToast("error", response.error_msg);
          } else {
            let refundArr = [];
            for (let i = 0; i < response?.data?.length; i++) {
              let obj = {
                customerName: response.data[i].customer_name,
                customerEmail: response.data[i].customer_email,
                invoiceId: response.data[i].id,
                requestedAmount: response.data[i].requested_amount,
                refundAmount: response.data[i].refund_amount,
                currencyCode: response.data[i].currency_code,
                refundStatusValue: response.data[i].refund_status,
                status: response.data[i].description,
                created: response.data[i].start_date,
              };
              refundArr.push(obj);
            }
            this.setState({
              refundList: refundArr,
            });
          }
        }.bind(this)
      )
      .catch(
        function (err) {
          this.setState({ showLoader: false });
          showHttpError(err);
        }.bind(this)
      );
  };

  openRefundModal = (id, requestedAmount, currencyCode) => {
    this.setState({
      selectedInvoiceId: id,
      requestedRefundAmount: requestedAmount,
      refundModalOpen: true,
      selectedCurrencyCode: currencyCode,
    });
  };

  closeRefundModal = () => {
    this.setState({
      selectedInvoiceId: null,
      requestedRefundAmount: null,
      refundModalOpen: false,
      refundAmountInput: null,
      selectedCurrencyCode: "",
    });
  };

  handleRefundAmountChange = (event) => {
    var { name, value } = event.target;
    if (_isOnlyNumber(value)) {
      this.setState({ [name]: value });
    } else {
      this.setState({ [name]: "" });
    }
  };

  updateRefundStatus = (id, refundAmount, statusCode) => {
    if (refundAmount <= 0) {
      showToast("error", "Refund amount must be greater than 0");
      return;
    } else if (refundAmount > this.state.requestedRefundAmount) {
      showToast("error", "Refund amount must be lesser than requested amount");
      return;
    } else {
      let payload = {
        merchant_uuid: getAuthUuid(),
        status: statusCode,
        amount: Number(refundAmount),
        id: id,
      };
      this.setState({ showLoader: true });
      update_refund_status(payload)
        .then(
          function (res) {
            let response = res.data[0];
            this.setState({ showLoader: false });
            if (response.error != "0") {
              showToast("error", response.error_msg);
            } else {
              showToast("success", response.error_msg);
              this.setState({
                selectedInvoiceId: null,
                requestedRefundAmount: null,
                refundModalOpen: false,
                refundAmountInput: null,
                selectedCurrencyCode: "",
              });
              setTimeout(() => {
                this.getRefundList();
              }, 2000);
            }
          }.bind(this)
        )
        .catch(
          function (err) {
            this.setState({ showLoader: false });
            showHttpError(err);
          }.bind(this)
        );
    }
  };

  rejectRefund = (id, refundAmount, statusCode) => {
    let payload = {
      merchant_uuid: getAuthUuid(),
      status: statusCode,
      amount: Number(refundAmount),
      id: id,
    };
    this.setState({ showLoader: true });
    update_refund_status(payload)
      .then(
        function (res) {
          let response = res.data[0];
          this.setState({ showLoader: false });
          if (response.error != "0") {
            showToast("error", response.error_msg);
          } else {
            showToast("success", response.error_msg);
            setTimeout(() => {
              this.getRefundList();
            }, 2000);
          }
        }.bind(this)
      )
      .catch(
        function (err) {
          this.setState({ showLoader: false });
          showHttpError(err);
        }.bind(this)
      );
  };

  openIssueRefundModal = (item) => {
    const assetInfo = handleDynamicCurrencyDetiails(
      this.state.assets,
      item.currency_id
    );
    const walletBalance = assetInfo?.coinBalance || "0.000000";
    this.setState({
      issueRefundModalOpen: true,
      issueRefundItem: {
        ...item,
        assetCode: assetInfo?.assetCode || "",
        walletBalance,
      },
      issueRefundAmount: "",
      issueRefundReason: "Customer Request",
      issueRefundNote: "",
    });
  };

  closeIssueRefundModal = () => {
    this.setState({
      issueRefundModalOpen: false,
      issueRefundItem: null,
      issueRefundAmount: "",
      issueRefundReason: "Customer Request",
      issueRefundNote: "",
    });
  };

  handleIssueRefund = () => {
    const {
      issueRefundItem,
      issueRefundAmount,
      issueRefundReason,
      issueRefundNote,
    } = this.state;
    if (!issueRefundAmount || Number(issueRefundAmount) <= 0) {
      showToast("error", "Please enter a valid refund amount");
      return;
    }
    if (Number(issueRefundAmount) > Number(issueRefundItem.amount_to_be_paid)) {
      showToast("error", "Refund amount cannot exceed the total paid amount");
      return;
    }
    let payload = {
      merchant_uuid: getAuthUuid(),
      invoice_id: issueRefundItem.invoice_id,
      amount: Number(issueRefundAmount),
      reason: issueRefundReason,
      note: issueRefundNote,
      status: 2,
    };
    this.setState({ showLoader: true });
    update_refund_status(payload)
      .then(
        function (res) {
          let response = res.data[0];
          this.setState({ showLoader: false });
          if (response.error != "0") {
            showToast("error", response.error_msg);
          } else {
            showToast("success", "Refund issued successfully");
            this.closeIssueRefundModal();
            setTimeout(() => {
              this.handleInvoiceType(this.state.txnType);
            }, 1500);
          }
        }.bind(this)
      )
      .catch(
        function (err) {
          this.setState({ showLoader: false });
          showHttpError(err);
        }.bind(this)
      );
  };

  handleInvoiceType = (param) => {
    this.searchString.current.value = "";
    this.setState({
      txnType: param,
    });
    if (param == "all") {
      this.handleAllInvoice();
    } else if (param == "paid") {
      this.handleAllPaidInvoice();
    } else if (param == "testuser") {
      this.handleAllTestUser();
    } else if (param == "refund") {
      this.getRefundList();
    } else {
      this.handleAllUnResolvedInvoice();
    }
  };

  renderPaginationPageNo = () => {
    let maxPageLimit = Math.ceil(
      parseInt(this.state.totalCount) / parseInt(this.state.noOfItemsPerPage)
    );
    let pageList = [];
    for (let i = 1; i <= maxPageLimit; i++) {
      pageList.push(i);
    }
    this.setState({
      pageList: pageList,
    });
  };

  componentDidMount() {
    this.handleRenderAssets();
    this.getRefundList();
  }

  render() {
    const filters = [
      { key: "all", label: "All" },
      { key: "paid", label: "Paid" },
      { key: "unresolved", label: "Unresolved" },
      { key: "testuser", label: "Test User" },
      { key: "refund", label: "Refund Requests" },
    ];

    return (
      <Fragment>
        <div className="container-scroller">
          <Sidebar />
          <Header />
          <div className="main-panel">
            <div style={ps.pageWrapper}>
              {/* Page Header */}
              <div style={ps.headerRow}>
                <PageHeader
                  icon="mdi-swap-horizontal"
                  title="Transactions"
                  subtitle="View and manage all payment transactions"
                />
                <div style={ps.searchBox}>
                  {/* <i
                    className="fas fa-search"
                    style={{
                      padding: "0 0 0 14px",
                      fontSize: "13px",
                      opacity: 0.3,
                    }}
                  ></i> */}
                  <input
                    type="text"
                    style={ps.searchInput}
                    placeholder="Search invoices..."
                    ref={this.searchString}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") this.handleSearchAllInvoice();
                    }}
                  />
                  <button
                    style={ps.searchBtn}
                    type="button"
                    onClick={this.handleSearchAllInvoice}
                  >
                    Search
                  </button>
                </div>
              </div>

              {/* Filter Tabs */}
              <div style={ps.filterBar}>
                {filters.map((f) => (
                  <button
                    key={f.key}
                    type="button"
                    style={ps.filterBtn(this.state.txnType === f.key)}
                    onClick={() => {
                      this.setState({ pageNo: "1" }, () => {
                        this.handleInvoiceType(f.key);
                      });
                    }}
                  >
                    {f.label}
                  </button>
                ))}
              </div>

              {/* Table Card */}
              <div style={ps.card}>
                {this.state.txnType !== "refund" ? (
                  <>
                    <div style={ps.tableWrapper}>
                      <table style={ps.table}>
                        <thead>
                          <tr>
                            <th style={ps.th}>Name</th>
                            <th style={ps.th}>Email</th>
                            <th style={ps.th}>Invoice ID</th>
                            <th style={ps.th}>Date</th>
                            <th style={ps.th}>Description</th>
                            <th style={ps.th}>Currency</th>
                            <th style={{ ...ps.th, textAlign: "right" }}>
                              Amount
                            </th>
                            <th style={ps.th}>Status</th>
                            <th style={{ ...ps.th, textAlign: "center" }}>
                              {this.state.txnType !== "testuser"
                                ? "Mark Test"
                                : "Mark Real"}
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {this.state.paymentList.map((item) => {
                            const statusInfo = getStatusInfo(item.status);
                            return (
                              <tr key={item.invoice_id} style={ps.trHover}>
                                <td style={{ ...ps.td, fontWeight: "600" }}>
                                  {item.name}
                                </td>
                                <td style={{ ...ps.td, opacity: 0.7 }}>
                                  {item.email}
                                </td>
                                <td style={ps.td}>
                                  <span
                                    style={{
                                      fontFamily: "monospace",
                                      fontSize: "12px",
                                      padding: "3px 8px",
                                      background: "var(--body-color-less2)",
                                      borderRadius: "6px",
                                    }}
                                  >
                                    {item.invoice_id}
                                  </span>
                                </td>
                                <td style={{ ...ps.td, opacity: 0.7 }}>
                                  <Moment
                                    format="MMM DD, YYYY"
                                    date={item.created}
                                  />
                                </td>
                                <td
                                  style={{
                                    ...ps.td,
                                    maxWidth: "180px",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                  }}
                                >
                                  {item.product_description}
                                </td>
                                <td style={{ ...ps.td, fontWeight: "600" }}>
                                  {
                                    handleDynamicCurrencyDetiails(
                                      this.state.assets,
                                      item.currency_id
                                    )?.assetCode
                                  }
                                </td>
                                <td
                                  style={{
                                    ...ps.td,
                                    textAlign: "right",
                                    fontWeight: "600",
                                    fontFamily: "monospace",
                                  }}
                                >
                                  {formatAmount(item.amount_to_be_paid, 5)}
                                </td>
                                <td style={ps.td}>
                                  {statusInfo.label && (
                                    <span
                                      style={ps.statusBadge(statusInfo.color)}
                                    >
                                      <span
                                        style={ps.statusDot(statusInfo.color)}
                                      ></span>
                                      {statusInfo.label}
                                    </span>
                                  )}
                                  {statusInfo.label === "Paid" && (
                                    <button
                                      style={{
                                        marginLeft: "8px",
                                        padding: "4px 12px",
                                        background: "var(--primary-color)",
                                        color: "#fff",
                                        border: "none",
                                        borderRadius: "6px",
                                        fontSize: "12px",
                                        fontWeight: "600",
                                        cursor: "pointer",
                                      }}
                                      onClick={() =>
                                        this.openIssueRefundModal(item)
                                      }
                                    >
                                      View
                                    </button>
                                  )}
                                </td>
                                <td style={{ ...ps.td, textAlign: "center" }}>
                                  <input
                                    type="checkbox"
                                    onClick={(e) => {
                                      this.markUserAsTestUser(item, e);
                                    }}
                                    checked={this.state.txnType === "testuser"}
                                    style={ps.checkbox}
                                    readOnly
                                  />
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>

                      {/* Empty State */}
                      {this.state.paymentList.length === 0 &&
                        !this.state.showLoader && (
                          <div style={ps.emptyState}>
                            <div style={ps.emptyIcon}>
                              <i className="fas fa-file-invoice"></i>
                            </div>
                            <p style={ps.emptyText}>No invoices found</p>
                          </div>
                        )}
                    </div>

                    {/* Pagination */}
                    {this.state.paymentList.length > 0 &&
                      this.state.pageList.length > 1 && (
                        <div style={ps.paginationRow}>
                          {this.state.pageList.map((page) => (
                            <button
                              type="button"
                              key={page}
                              style={ps.pageBtn(this.state.pageNo == page)}
                              onClick={() => {
                                this.setState({ pageNo: page }, () => {
                                  this.handleInvoiceType(this.state.txnType);
                                });
                              }}
                            >
                              {page}
                            </button>
                          ))}
                        </div>
                      )}
                  </>
                ) : (
                  <div style={ps.tableWrapper}>
                    <table style={ps.table}>
                      <thead>
                        <tr>
                          <th style={ps.th}>Customer</th>
                          <th style={ps.th}>Email</th>
                          <th style={ps.th}>Invoice ID</th>
                          <th style={ps.th}>Requested Amt</th>
                          <th style={ps.th}>Refund Amt</th>
                          <th style={ps.th}>Date</th>
                          <th style={ps.th}>Description</th>
                          <th style={ps.th}>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {this.state.refundList.map((item) => (
                          <tr key={item.invoiceId} style={ps.trHover}>
                            <td style={{ ...ps.td, fontWeight: "600" }}>
                              {item.customerName}
                            </td>
                            <td style={{ ...ps.td, opacity: 0.7 }}>
                              {item.customerEmail}
                            </td>
                            <td style={ps.td}>
                              <span
                                style={{
                                  fontFamily: "monospace",
                                  fontSize: "12px",
                                  padding: "3px 8px",
                                  background: "var(--body-color-less2)",
                                  borderRadius: "6px",
                                }}
                              >
                                {item.invoiceId}
                              </span>
                            </td>
                            <td style={{ ...ps.td, fontWeight: "600" }}>
                              {item.requestedAmount} {item.currencyCode}
                            </td>
                            <td style={ps.td}>
                              {item.refundAmount} {item.currencyCode}
                            </td>
                            <td style={{ ...ps.td, opacity: 0.7 }}>
                              {item.created}
                            </td>
                            <td style={ps.td}>{item.status}</td>
                            <td style={ps.td}>
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                }}
                              >
                                <button
                                  style={ps.actionBtn("green")}
                                  onClick={() =>
                                    this.openRefundModal(
                                      item.invoiceId,
                                      item.requestedAmount,
                                      item.currencyCode
                                    )
                                  }
                                  disabled={item.refundStatusValue > 1}
                                  title={
                                    item.refundStatusValue === 1
                                      ? "Accept Refund"
                                      : ""
                                  }
                                >
                                  <i className="fas fa-check"></i>
                                </button>
                                <button
                                  style={ps.actionBtn("red")}
                                  onClick={() =>
                                    this.rejectRefund(
                                      item.invoiceId,
                                      item.requestedAmount,
                                      3
                                    )
                                  }
                                  disabled={item.refundStatusValue > 1}
                                  title={
                                    item.refundStatusValue === 1
                                      ? "Reject Refund"
                                      : ""
                                  }
                                >
                                  <i className="fas fa-xmark"></i>
                                </button>
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>

                    {/* Empty State */}
                    {this.state.refundList.length === 0 &&
                      !this.state.showLoader && (
                        <div style={ps.emptyState}>
                          <div style={ps.emptyIcon}>
                            <i className="fas fa-rotate-left"></i>
                          </div>
                          <p style={ps.emptyText}>No refund requests found</p>
                        </div>
                      )}
                  </div>
                )}
              </div>
            </div>
            <Footer />
          </div>
          <Loader show={this.state.showLoader} />
        </div>

        {/* Refund Modal */}
        <Modal
          show={this.state.refundModalOpen}
          backdrop="static"
          keyboard={false}
          centered
        >
          <div style={ps.modalHeader}>
            <h3 style={ps.modalTitle}>Process Refund</h3>
            <button
              type="button"
              style={ps.modalClose}
              onClick={this.closeRefundModal}
            >
              <i className="fas fa-xmark"></i>
            </button>
          </div>
          <div style={ps.modalBody}>
            <div style={ps.modalRequestedBadge}>
              <i
                className="fas fa-circle-info"
                style={{ color: "var(--btn-color)", fontSize: "14px" }}
              ></i>
              <span>
                Requested:{" "}
                <strong>
                  {this.state.requestedRefundAmount}{" "}
                  {this.state.selectedCurrencyCode}
                </strong>
              </span>
            </div>

            <label style={ps.modalLabel}>Refund Amount</label>
            <input
              type="text"
              style={ps.modalInput}
              name="refundAmountInput"
              value={
                this.state.refundAmountInput === null
                  ? ""
                  : this.state.refundAmountInput
              }
              onChange={this.handleRefundAmountChange}
              placeholder="Enter amount to refund"
            />
          </div>
          <div style={ps.modalFooter}>
            <button
              type="button"
              style={{
                ...ps.btnRefund,
                ...(this.state.refundAmountInput === null
                  ? ps.btnDisabled
                  : {}),
              }}
              disabled={this.state.refundAmountInput === null}
              onClick={() =>
                this.updateRefundStatus(
                  this.state.selectedInvoiceId,
                  this.state.refundAmountInput,
                  2
                )
              }
            >
              Refund Custom Amount
            </button>
            <button
              type="button"
              style={ps.btnRefundFull}
              onClick={() =>
                this.updateRefundStatus(
                  this.state.selectedInvoiceId,
                  this.state.requestedRefundAmount,
                  2
                )
              }
            >
              Refund Full Amount
            </button>
          </div>
        </Modal>
        {/* Issue Refund Modal */}
        <Modal
          show={this.state.issueRefundModalOpen}
          backdrop="static"
          keyboard={false}
          centered
          size="md"
        >
          {this.state.issueRefundItem && (
            <>
              {/* Header */}
              <div style={ps.issueRefundHeader}>
                <h3 style={ps.issueRefundTitle}>
                  <span style={ps.issueRefundTitleIcon}>
                    <i className="fas fa-rotate-left"></i>
                  </span>
                  Issue Refund
                </h3>
                <button
                  type="button"
                  style={ps.modalClose}
                  onClick={this.closeIssueRefundModal}
                >
                  <i className="fas fa-xmark"></i>
                </button>
              </div>

              {/* Body */}
              <div style={ps.issueRefundBody}>
                {/* Invoice & Total Paid */}
                <div style={ps.issueRefundInvoiceBadge}>
                  <div>
                    <div style={ps.issueRefundInvoiceLabel}>Invoice</div>
                    <div style={ps.issueRefundInvoiceValue}>
                      #{this.state.issueRefundItem.invoice_id}
                    </div>
                  </div>
                  <div>
                    <div
                      style={{
                        ...ps.issueRefundInvoiceLabel,
                        textAlign: "right",
                      }}
                    >
                      Total Paid
                    </div>
                    <div style={ps.issueRefundTotalPaid}>
                      {formatAmount(
                        this.state.issueRefundItem.amount_to_be_paid,
                        6
                      )}{" "}
                      <span style={{ color: "#6366f1" }}>
                        {this.state.issueRefundItem.assetCode}
                      </span>
                    </div>
                  </div>
                </div>

                {/* Refund Amount */}
                <div style={ps.issueRefundFieldGroup}>
                  <label style={ps.issueRefundLabel}>Refund Amount</label>
                  <div style={{ position: "relative" }}>
                    <input
                      type="text"
                      style={{ ...ps.issueRefundInput, paddingRight: "60px" }}
                      placeholder="0.000000"
                      value={this.state.issueRefundAmount}
                      onChange={(e) => {
                        if (
                          _isOnlyNumber(e.target.value) ||
                          e.target.value === ""
                        ) {
                          this.setState({ issueRefundAmount: e.target.value });
                        }
                      }}
                    />
                    <span
                      style={{
                        position: "absolute",
                        right: "16px",
                        top: "50%",
                        transform: "translateY(-50%)",
                        fontSize: "13px",
                        fontWeight: "700",
                        color: "#6366f1",
                        pointerEvents: "none",
                      }}
                    >
                      {this.state.issueRefundItem.assetCode}
                    </span>
                  </div>
                </div>

                {/* Info Rows */}
                <div style={{ marginBottom: "20px" }}>
                  <div style={ps.issueRefundInfoRow}>
                    <span style={ps.issueRefundInfoLabel}>Network Fee</span>
                    <span style={ps.issueRefundInfoValue}>--</span>
                  </div>
                  <div
                    style={{ ...ps.issueRefundInfoRow, borderBottom: "none" }}
                  >
                    <span style={ps.issueRefundInfoLabel}>
                      Available in Merchant Wallet
                    </span>
                    <span style={ps.issueRefundInfoValue}>
                      {formatAmount(
                        this.state.issueRefundItem.walletBalance,
                        6
                      )}{" "}
                      <span style={{ color: "#6366f1", fontFamily: "inherit" }}>
                        {this.state.issueRefundItem.assetCode}
                      </span>
                    </span>
                  </div>
                </div>

                <div style={ps.issueRefundDivider}></div>

                {/* Refund Reason */}
                <div style={ps.issueRefundFieldGroup}>
                  <label style={ps.issueRefundLabel}>Refund Reason</label>
                  <select
                    style={ps.issueRefundSelect}
                    value={this.state.issueRefundReason}
                    onChange={(e) =>
                      this.setState({ issueRefundReason: e.target.value })
                    }
                  >
                    <option value="Customer Request">Customer Request</option>
                    <option value="Order Canceled">Order Canceled</option>
                    <option value="Order Not Fulfilled">
                      Order Not Fulfilled
                    </option>
                    <option value="Duplicate Payment">Duplicate Payment</option>
                    <option value="Incorrect Amount Charged">
                      Incorrect Amount Charged
                    </option>
                    <option value="Overpayment Correction">
                      Overpayment Correction
                    </option>
                    <option value="Suspected Fraud">Suspected Fraud</option>
                    <option value="Merchant Error">Merchant Error</option>
                    <option value="Other">Other</option>
                  </select>
                </div>

                {/* Note */}
                <div style={ps.issueRefundFieldGroup}>
                  <label style={ps.issueRefundLabel}>Note (optional)</label>
                  <textarea
                    style={ps.issueRefundTextarea}
                    placeholder="Add any additional details about this refund..."
                    value={this.state.issueRefundNote}
                    onChange={(e) =>
                      this.setState({ issueRefundNote: e.target.value })
                    }
                  />
                </div>
              </div>

              {/* Footer Buttons */}
              <div style={ps.issueRefundFooter}>
                <button
                  type="button"
                  style={ps.issueRefundBtnCancel}
                  onClick={this.closeIssueRefundModal}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  style={{
                    ...ps.issueRefundBtnSubmit,
                    ...(!this.state.issueRefundAmount ||
                    Number(this.state.issueRefundAmount) <= 0
                      ? ps.btnDisabled
                      : {}),
                  }}
                  disabled={
                    !this.state.issueRefundAmount ||
                    Number(this.state.issueRefundAmount) <= 0
                  }
                  onClick={this.handleIssueRefund}
                >
                  <i
                    className="fas fa-rotate-left"
                    style={{ marginRight: "6px" }}
                  ></i>
                  Issue Refund
                </button>
              </div>

              {/* Disclaimer */}
              <div style={ps.issueRefundDisclaimer}>
                <i
                  className="fas fa-circle-info"
                  style={{ fontSize: "13px", flexShrink: 0 }}
                ></i>
                <span>
                  Refunds are automatically processed and issued to your
                  customer by the payment processor.
                </span>
              </div>
            </>
          )}
        </Modal>
      </Fragment>
    );
  }
}

export default withRouter(Payments);
